import { termInChinese } from "@/utility/termInChinese.js";

export default {
  computed: {
    // 取得年表、財務比例分析＿年，共用各區 Period 期別標題與 labels 種類次標題。
    fieldsOfYear: () => labels => {
      return [
        {
          key: "subTitle",
          label: "種類",
          stickyColumn: true
          // isRowHeader: true
          // variant: "info"
        },
        ...labels.map(field => {
          return {
            key: field.year.toString(10),
            label: "合併",
            tdClass: "tdClass",
            // 保留原本型別 number 數值，純畫面字串化顯示。
            formatter: value => {
              return value.toLocaleString().replace(/-(.+)/g, "($1)");
            }
          };
        })
      ];
    },

    // chart 線軸格式包含 type, data(datasets), options 統一轉換。
    datasetsOfChartYear: () => (label, data, color) => ({
      label: termInChinese.get(label),
      data,
      pointBackgroundColor: color, // 圓點顏色。
      borderColor: color // 折線顏色。
      // pointStyle: "rectRounded",
      // pointRadius: 2.5, // 方圓點尺寸。
      // borderWidth: 1.7, // 折線粗細。
      // fill: false, // 背景色關閉。
      // lineTension: 0 // 設定曲線，直線為零。
    }),
    optionsOfChartYear: () => (text, labels, step) => ({
      // tooltips: {
      // mode: "index", // 查找具有相同索引的項目。
      // intersect: true // 鼠標與元素相交時工具提示模式，預設值。
      // },
      maintainAspectRatio: false, //canvas 不縮放。若縮放，再手機版時高的比例被拉長
      title: {
        text: termInChinese.get(text)
        // display: true, // 顯示標題。
        // fontColor: "#343a40",
        // fontSize: 17,
        // position: "top" // 標題位置，預設值。
      },
      tooltips: {
        callbacks: {
          /* eslint-disable-next-line no-unused-vars */
          label: function(tooltipItem, data) {
            // 修改每點 hover 出的數字，加入千本位逗號
            return tooltipItem.yLabel
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        }
      },
      scales: {
        yAxes: [
          {
            ticks: {
              stepSize: step || 10, // 階層差距設定。
              callback(value) {
                if (value !== 0)
                  return step
                    ? [value].toLocaleString()
                    : `${value.toFixed(2)}%`;
                // 修改 Y 軸標題格式。
                else return 0;
                // suggestedMin: 0, // Y 軸最小預設值。
                // Y 軸最大預設值，使用 suggestedMax 支援增長或縮短機制，符合非固定 range 要求。
                // suggestedMax: 10,
              }
            }
          }
        ],
        xAxes: [
          {
            // 預防性重新調整年度排序為近期至遠程。
            labels: labels.map(item => item.x).sort((a, b) => b - a),
            ticks: {
              callback(value) {
                return value.toString().slice(-2); // 呈現 X 軸末兩碼。
              }
            }
            // type: "category", // 此為 X 軸線類別預設值。
          }
        ]
      }
    }),
    optionsOfPriceChartYear: () => (text, labels, step) => ({
      maintainAspectRatio: false, //搭配 inline style min-height 調整 canvas height。canvas 不縮放，這樣手機版時高的比例才不會被拉長。
      title: {
        text: termInChinese.get(text)
      },
      tooltips: {
        callbacks: {
          /* eslint-disable-next-line no-unused-vars */
          label: function(tooltipItem, data) {
            // 修改每點 hover 出的數字，加入千本位逗號
            return tooltipItem.yLabel
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }
        }
      },
      scales: {
        yAxes: [
          {
            ticks: {
              callback(value) {
                // 修改 Y 軸數字，加入千本位逗號跟單位。
                if (value !== 0)
                  return step
                    ? [value].toLocaleString()
                    : `${value
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}百萬`;
                else return 0;
              }
            }
          }
        ],
        xAxes: [
          {
            // 預防性重新調整年度排序為近期至遠程。
            labels: labels.map(item => item.x).sort((a, b) => b - a),
            ticks: {
              callback(value) {
                return value.toString().slice(-2); // 呈現 X 軸末兩碼。
              }
            }
          }
        ]
      }
    })
  }
};
